import React, { PureComponent } from "react";
import PropTypes from "prop-types";
import ReactCodeInput from "react-code-input";
import logoHeader from "../Layout/assets/hwk_logo_150.png";
import "./Login.css";

class Login extends PureComponent {
  static propTypes = {
    onLogin: PropTypes.func
  };

  static defaultProps = {
    onLogin: () => {}
  };

  state = {
    pin: ""
  };

  onChange = value => {
    this.setState(
      {
        pin: value
      },
      () => {
        if (this.state.pin && this.state.pin.length === 6) {
          this.props.onLogin(this.state.pin);
        }
      }
    );
  };

  render() {
    return (
      <div className="login-wrap">
        <div className="login-container">
          <div className="logo">
            <img src={logoHeader} alt="HWK Skiwax" />
          </div>
          <span>Enter PIN number:</span>
          <ReactCodeInput
            type="password"
            fields={6}
            value={this.state.pin}
            onChange={this.onChange}
          />
        </div>
      </div>
    );
  }
}

export default Login;
